<template>
    <x-page title="Report">
        <x-app-button
            icon="users"
            label="Group Update"
            url="/admin/reports/attendance-update"
            v-if="can('viewAttendanceUpdateReport')"
        />

        <x-app-button
            icon="id-badge"
            label="Group Role"
            url="/admin/reports/group-roles"
        />

        <x-app-button
            icon="calendar-check-o"
            label="Absensi"
            :url="attendanceReportUrl"
            v-if="can('viewAttendanceReport')"
        />

        <x-app-button
            icon="cubes"
            label="Department Report"
            url="/admin/reports/attendance-overview"
            v-if="can('viewAttendanceOverviewReport')"
        />

        <x-app-button
            icon="bar-chart"
            label="Metrics"
            url="/admin/reports/metrics"
        />

        <x-app-button
            icon="line-chart"
            label="Statistik"
            url="/admin/reports/group-statistics"
            v-if="can('viewGroupStatisticTemplates')"
        />

        <x-app-button
            icon="pie-chart"
            label="Usia Jemaat"
            url="/admin/reports/member-age"
        />
    </x-page>
</template>

<script>
import XAppButton from "../../components/XAppButton.vue";
import XPage from "../../components/XPage.vue";
import { attendanceDetailUrl } from "../../helpers";
import PermissionMixin from "../../mixins/PermissionMixin";

export default {
    components: {
        XPage,
        XAppButton,
    },
    computed: {
        attendanceReportUrl() {
            return attendanceDetailUrl();
        },
    },
    mixins: [PermissionMixin],
};
</script>
